/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface UserWithNoId
 */
export interface UserWithNoId {
  _id?: string;
    /**
     * 
     * @type {Date}
     * @memberof UserWithNoId
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserWithNoId
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof UserWithNoId
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserWithNoId
     */
    firstname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserWithNoId
     */
    lastname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserWithNoId
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserWithNoId
     */
    isEmailVerified?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserWithNoId
     */
    role?: UserWithNoIdRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UserWithNoId
     */
    phoneNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof UserWithNoId
     */
    dateOfBirth?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserWithNoId
     */
    lastActive?: Date;
    /**
     * 
     * @type {string}
     * @memberof UserWithNoId
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof UserWithNoId
     */
    storeId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserWithNoId
     */
    customerType?: UserWithNoIdCustomerTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserWithNoId
     */
    adminStores?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UserWithNoId
     */
    isEmailNotifActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserWithNoId
     */
    isSmsNotifActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserWithNoId
     */
    alertOnUserRegistration?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserWithNoId
     */
    alertOnOrderCreation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserWithNoId
     */
    alertOnOrderDelivery?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserWithNoId
     */
    alertOnNewReview?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserWithNoId
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserWithNoId
     */
    isBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserWithNoId
     */
    isTaxExempted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserWithNoId
     */
    stripeCustomerId?: string;
    /**
     * ISO 3166-1 alpha-2 country code ... examples -> https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
     * @type {string}
     * @memberof UserWithNoId
     */
    country?: string;
    /**
     * 
     * @type {number}
     * @memberof UserWithNoId
     */
    availableCreditBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof UserWithNoId
     */
    creditLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof UserWithNoId
     */
    creditUsed?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserWithNoId
     */
    isAllowedtToUseCredit?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum UserWithNoIdRoleEnum {
    SuperAdmin = 'SuperAdmin',
    Admin = 'Admin',
    User = 'User'
}
/**
    * @export
    * @enum {string}
    */
export enum UserWithNoIdCustomerTypeEnum {
    B2B = 'B2B',
    Regular = 'Regular'
}

